module.exports = __webpack_public_path__ + "img/008.15ec35a7.png";